import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

import { SnackBarConfig } from 'v2/modules/shared/configs/snackbar.config';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingUtilService {
  constructor(private snackBar :MatSnackBar) {}

  handleError(
    error :any,
    defaultMessage :string = 'An error occurred. Please try again later or contact support.',
    action :string = 'Fail',
  ) :void {
    const errorMessage = error?.error.error ?? error?.error;
    this.snackBar.open(errorMessage || defaultMessage, action, {
      duration: SnackBarConfig.DEFAULT.duration,
    });
  }
}
